/**
 * Lookup to the `recordview` object (or recordview id fields) should not link to
 * `/view/recordview/:id` in detail or list. Optional `requireLookupType: false` for
 * table cells where `type` may be omitted but `isReference` / `referenceObject` is set.
 */
export function isRecordviewObjectLookupField(field, options = {}) {
  const { requireLookupType = true } = options;
  if (!field || typeof field !== 'object') return false;
  if (requireLookupType && String(field.type || '').toLowerCase() !== 'lookup') {
    return false;
  }
  const ref =
    field.referenceObject != null
      ? String(field.referenceObject).trim().toLowerCase()
      : field.reference_object != null
        ? String(field.reference_object).trim().toLowerCase()
        : '';
  const fn =
    field.fieldName != null
      ? String(field.fieldName).trim().toLowerCase()
      : field.field_name != null
        ? String(field.field_name).trim().toLowerCase()
        : '';
  return ref === 'recordview' || fn === 'recordviewid' || fn === 'recordview_id';
}
